<template>
    <div class="w-full">
        <section-title 
            fontSmall
            title="Province Information"
        >
            <p class="text-sm font-medium text-neutral-600">Please fill out all the required fields with the red asterisk (<span class="text-red-600">*</span>)</p>
        </section-title>
        <form class="grid grid-cols-2 gap-6 mt-6">
            <div class="col-span-2 border-t border-gray-200"></div>

            <div class="col-span-2">
                <text-input
                    type="text"
                    label="Province code"
                    placeholder="province code"
                    name="code"
                    id="code"
                    v-model="form.code"
                    :error="errors?.code"
                    required
                />
            </div>

            <div class="col-span-2">
                <multi-select 
                    searchable
                    :options="regionOptions"
                    id="region"
                    name="region"
                    label="Region"
                    placeholder="Select.."
                    v-model="form.region_id"
                    :error="errors?.region_id"
                    required
                />
            </div>
            
            <div class="col-span-2">
                <text-input
                    type="text"
                    label="Province name"
                    placeholder="Province name"
                    name="name"
                    id="name"
                    v-model="form.name"
                    :error="errors?.name"
                    required
                />
            </div>
            
            <slot></slot>
        </form>
    </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import MultiSelect from "@/components/inputs/MultiSelect.vue";

import {
    LocationDataInterface,
    SelectInterface
} from "@/interfaces/Settings/LocationInterface"

import DropdownService from "@/classes/Dropdowns/DropdownService";

const props = defineProps({
    form: {
        type: Object as () => LocationDataInterface,
        defualt: [],
        required: true,
    },
    errors: {
        type: Object,
        defualt: [],
        required: true,
    },
});


const form = ref<LocationDataInterface>(props.form);
const regionOptions = ref<SelectInterface>([])

const getRegions = ():void => {
    DropdownService
        .regions()
        .then(({data}) => {
            regionOptions.value = data;
        })
}

onMounted(() => {
    getRegions()
})
</script>